import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { AuthHttp } from "angular2-jwt/angular2-jwt";
import { SessionStorageService } from "ngx-webstorage/dist/services";
import { ConstantService } from "../../../components/common/utils/constant.service";
import { ClienteLogin, Cliente, ClienteXCiudad } from "../../login/cliente_login";
import { Headers, Http, Response, RequestOptions, ResponseContentType } from '@angular/http';
import { PolizaVAM, ConsultaSiniestralidad,ConsultaCliente,BusquedaFacturacion ,BusquedaSiniestralidad} from '../entities/vam_entities';
import { ComboBox, ObjMultiSelect } from "../../../components/common/utils/combobox";
import { Tracking, ConsultaTracking } from '../../../components/common/utils/entities/tracking-siniestros';
import { Titulares } from '../../vam/titulares/entities/vam_titulares_entity';

declare var jQuery: any;

@Injectable()
export class siniestralidadService {
    private url = "siniestralidad";

    constructor(private authHttp: AuthHttp, private sessionStorageService: SessionStorageService) {
        let constantService = new ConstantService();
        this.url = constantService.API_ENDPOINT + this.url;
    }

    consultaSiniestralidadVAMEmpresa(poliza: PolizaVAM): Observable<ConsultaSiniestralidad>{
       
        let body = JSON.stringify(poliza);
        let headers = new Headers({ 'Content-Type': 'application/json',
        'Authorization' : "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url + "/consultaSiniestralidad/", body, options)
            .map(this.extractData)
            .catch(this.handleError);
    }
    
    getClientes(parametros: ConsultaCliente): Observable<ComboBox[]> {
        let body = JSON.stringify(parametros);
        let headers = new Headers({ 'Content-Type': 'application/json' });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url + "/ConsultaClientes/", body, options)
            .map(this.extractData)
            .catch(this.handleError);
    }
    getTipoNegocio(parametros: BusquedaFacturacion): Observable<ComboBox[]> {
        let body = JSON.stringify(parametros);
        let headers = new Headers({ 'Content-Type': 'application/json' });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url + "/ConsultaTipoNegocio/", body, options)
            .map(this.extractData)
            .catch(this.handleError);
    }
    getRamos(parametros: BusquedaSiniestralidad): Observable<ObjMultiSelect[]> {
        let body = JSON.stringify(parametros);
        let headers = new Headers({ 'Content-Type': 'application/json' });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url + "/ConsultarRamos/", body, options)
            .map(this.extractData)
            .catch(this.handleError);
    }
    getAseguradora(parametros: BusquedaSiniestralidad): Observable<ComboBox[]> {
        let body = JSON.stringify(parametros);
        let headers = new Headers({ 'Content-Type': 'application/json' });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url + "/ConsultarAseguradora/", body, options)
            .map(this.extractData)
            .catch(this.handleError);
    }
    getGrupo(parametros: ConsultaCliente): Observable<number> {
        let body = JSON.stringify(parametros);
        let headers = new Headers({ 'Content-Type': 'application/json' });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url + "/ConsultarGrupo/", body, options)
            .map(this.extractData)
            .catch(this.handleError);
    }

    getPlanes(parametros: BusquedaSiniestralidad): Observable<ComboBox[]> {
        let body = JSON.stringify(parametros);
        let headers = new Headers({ 'Content-Type': 'application/json' });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url + "/ConsultarPlanes/", body, options)
            .map(this.extractData)
            .catch(this.handleError);
    }
    getDatosCliente(parametros: ConsultaCliente): Observable<ConsultaCliente> {
        let body = JSON.stringify(parametros);
        let headers = new Headers({ 'Content-Type': 'application/json' });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url + "/ConsultaDatosCliente/", body, options)
            .map(this.extractData)
            .catch(this.handleError);
    }
    exportarSiniestralidadVAMEmpresa(poliza: PolizaVAM):Observable<any>{
        let  body  =  JSON.stringify(poliza);
        let  headers  =  new  Headers({
            'Content-Type':  'application/json',
            'Accept':  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'Authorization' : "Token " + sessionStorage.getItem("Token")
        });
        let  options  =  new  RequestOptions({ headers:  headers  });
        options.responseType  =  ResponseContentType.Blob;;
        return this.authHttp.post(this.url + "/exportarExcelSiniestralidad/", body, options)
            .map(response => response).catch(this.handleError);
    }
    consultaSiniestrosTrackng(parametros: ConsultaTracking): Observable<Tracking[]>{
       
        let body = JSON.stringify(parametros);
        let headers = new Headers({ 'Content-Type': 'application/json',
        'Authorization' : "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url + "/consultaSiniestrosTracking/", body, options)
            .map(this.extractData)
            .catch(this.handleError);
    }
    consultaSiniestrosTrackngExcel(poliza: PolizaVAM):Observable<any>{
        let  body  =  JSON.stringify(poliza);
        let  headers  =  new  Headers({
            'Content-Type':  'application/json',
            'Accept':  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'Authorization' : "Token " + sessionStorage.getItem("Token")
        });
        let  options  =  new  RequestOptions({ headers:  headers  });
        options.responseType  =  ResponseContentType.Blob;;
        return this.authHttp.post(this.url + "/ExportarExcelTracking/", body, options)
            .map(response => response).catch(this.handleError);
    }
    getAdjuntoSiniestro(siniestro: Tracking): Observable<any> {
        let body = JSON.stringify(siniestro);
        let headers = new Headers({
            'Content-Type': 'application/json',
            'Accept': 'application/pdf'
        });
        let options = new RequestOptions({ headers: headers });
        options.responseType = ResponseContentType.Blob;
        return this.authHttp.post(this.url + "/DescargaAdjuntosTrackingpagados/", body, options)
            .map(response => response).catch(this.handleError);

    }
    getTitularPorCedula(parametros: Titulares): Observable<Titulares> {
        let body = JSON.stringify(parametros);
        let headers = new Headers({ 'Content-Type': 'application/json' });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url + "/ConsultarCedula/", body, options)
            .map(this.extractData)
            .catch(this.handleError);
    }
    consultarTitularesDependientes(cliente: ConsultaCliente){
        let body = JSON.stringify(cliente);
        let headers = new Headers({ 'Content-Type': 'application/json', 'Authorization' : "Token " + sessionStorage.getItem("Token") });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url + "/ConsultarTitulares", body, options).map(this.extractData)
            .catch(this.handleError);
    }
    getNotasCobranza(parametros: ConsultaCliente): Observable<Tracking[]> {
        let body = JSON.stringify(parametros);
        let headers = new Headers({ 'Content-Type': 'application/json' });
        let options = new RequestOptions({ headers: headers });
        return this.authHttp.post(this.url + "/ConsultarNotasCobranza/", body, options)
            .map(this.extractData)
            .catch(this.handleError);
    }
    private extractData(res: Response) {
        let body = res.json();
        return body || {};
    }
    private handleError(error: any) {
        return Observable.throw(error);
    }
}


// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/empresas/polizasContratadas/siniestralidad.service.ts